import { iconElementConfig } from '../../fuse-icon-element/src/icon-element';

const titleSizeConfig = {
	// heading sizes NOT viewport size
	heading: {
		xxsmall: '1',
		xsmall: '2',
		small: '3',
		medium: '4',
		large: '5',
		xlarge: '6',
	},
	// icon sizes NOT viewport size
	icon: {
		xxsmall: iconElementConfig.small.height, // 24px
		xsmall: iconElementConfig.small.height, // 24px
		small: iconElementConfig.small.height, // 24px
		medium: iconElementConfig.medium.height, // 32px
		large: iconElementConfig.large.height, // 40px
		xlarge: iconElementConfig.large.height, // 40px
	},
};

export default titleSizeConfig;
